import request from "root/js/request";

export const getAdvertSkuTableOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  group_by,
  q,
  limit,
  offset,
  order_by,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/advert_sku_table/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      group_by,
      q,
      limit,
      offset,
      order_by,
      ...rest,
    },
  });
  return response.data;
};
